export enum MessageDirection  {
    SENT,
    RECEIVED,
};

export enum MessageStatus {
    SENDING,
    RECEIVING,
    SENT,
    RECEIVED,
    ERROR_SENDING,
    ERROR_RECEIVING,
    UNKNOWN,
}

export enum MessageType {
    TEXT,
    QUICK_RESPONSE,
    CARD,
    CARD_CAROUSEL,
    TEXT_LINK
}

export default interface Message {
    messageIndex?:number;
    messageDirection?:MessageDirection;
    messageType?:MessageType;
    messageStatus?:MessageStatus;
    messageData?:any;
}